import {markInputRule} from "../helper/prosemirrorInputRules";
import AbstractMark from "./AbstractMark";
import {defaultMarkdownParser, schema as markdownSchema} from 'prosemirror-markdown';
import {toggleMark} from "prosemirror-commands";

const backticksFor = (node, side) => {
    const ticks = /`+/g;
    let match;
    let len = 0;

    if (node.isText) {
        while ((match = ticks.exec(node.text))) {
            len = Math.max(len, match[0].length);
        }
    }

    let result = len > 0 && side > 0 ? " `" : "`";

    for (let i = 0; i < len; i++) {
        result += "`";
    }

    if (len > 0 && side < 0) {
        result += " ";
    }

    return result;
}

export default class Code extends AbstractMark {
    get name() {
        return "code";
    }

    get schema() {
        return {
            ...markdownSchema.spec.marks.get("code"),
            excludes: "_"
        }
    }

    get toMarkdown() {
        return {
            open: function open(_state, _mark, parent, index) {
                return backticksFor(parent.child(index), -1)
            },
            close: function close(_state, _mark, parent, index) {
                return backticksFor(parent.child(index - 1), 1)
            },
            escape: false
        }
    }

    get parseMarkdown() {
        return defaultMarkdownParser.tokens.code_inline;
    }

    inputRules({type}) {
        return [markInputRule(/(?:^|[^`\\])(`([^`]+)`)$/, type)];
    }

    keys({type}) {
        return {
            "Mod-`": toggleMark(type)
        };
    }
}